// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__3s91P","vLegacy":"SelectSecondary_vLegacy__BB8ek","error":"SelectSecondary_error__1SJbr","disabled":"SelectSecondary_disabled__2hhGD"};